import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const getDashboardData = async (startDate, endDate) => {
    try {
        const start = `${startDate.toISOString().split('T')[0]} 00:00:00`;
        const end = `${endDate.toISOString().split('T')[0]} 23:59:59`;

        const result = await api.get(`${urlApi}/maintenance/dataDashboard?start=${start}&end=${end}`);
        console.log(result);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

